var map = {
	"./Bunny1.png": "a331",
	"./Bunny2.png": "0439",
	"./Carlitos1.png": "8a08",
	"./Carlitos2.png": "a390",
	"./Clusters-Icon-B3.png": "a486",
	"./GED_Practice.svg": "1746",
	"./HMP_COLOR.svg": "1252",
	"./Jenny1.png": "5579",
	"./Jenny2.png": "dcd6",
	"./SAT_Practice.svg": "097e",
	"./STARSgreen.png": "e009",
	"./State_test_Practice.svg": "d959",
	"./TPM-banner-rigth.svg": "f90b",
	"./TPM_yourpath.svg": "df37",
	"./account_circle-24px.svg": "146a",
	"./activity-time-calendar.svg": "678d",
	"./activity.svg": "0379",
	"./attendance.svg": "de6f",
	"./audio/correct1.mp3": "463f",
	"./audio/correct2.mp3": "4e9e",
	"./audio/correct3.mp3": "5ae6",
	"./audio/correct4.mp3": "e27d",
	"./audio/incorrect1.mp3": "e6c5",
	"./audio/incorrect2.mp3": "8237",
	"./audio/incorrect3.mp3": "eacc",
	"./audio/incorrect4.mp3": "b74d",
	"./audio/incorrect5.mp3": "f8cd",
	"./audio/incorrect6.mp3": "0b22",
	"./avatars/Avatar_girl.svg": "0022",
	"./avatars/ELEMENTARYavatars1.svg": "288b",
	"./avatars/ELEMENTARYavatars2.svg": "cffa",
	"./avatars/ELEMENTARYavatars3.svg": "754f",
	"./avatars/ELEMENTARYavatars4.svg": "2a90",
	"./avatars/HighSchool1.svg": "d97b",
	"./avatars/HighSchool2.svg": "8fe4",
	"./avatars/HighSchool3.svg": "d89c",
	"./avatars/HighSchool4.svg": "840c",
	"./avatars/MiddleSchoolAvatar01.svg": "6c90",
	"./avatars/MiddleSchoolAvatar02.svg": "1367",
	"./avatars/MiddleSchoolAvatar03.svg": "f924",
	"./avatars/MiddleSchoolAvatar04.svg": "9200",
	"./avatars/PreSchoolCat.svg": "a0da",
	"./avatars/PreSchoolElephant.svg": "b4aa",
	"./avatars/PreSchoolHipo.svg": "d8f6",
	"./avatars/PreSchoolMonkey.svg": "946a",
	"./avatars/PreSchoolOwl.svg": "fef4",
	"./avatars/avatarYellow.png": "1ddf",
	"./avatars/tutor1.svg": "a78fe",
	"./avatars/tutor2.svg": "9783",
	"./avatars/tutor3.svg": "9658",
	"./avatars/tutor4.svg": "db54",
	"./avatars/user.png": "2a06",
	"./avatars/user_generic.jpg": "dbc9",
	"./back.png": "336c",
	"./background-login.png": "945f",
	"./background.png": "30b3",
	"./c99bbe2.png": "ebe0",
	"./carousel/Asset_28.png": "08a4",
	"./carousel/Asset_28_right.png": "8022",
	"./carousel/flechaActiva1.png": "bcfd",
	"./carousel/flechaActiva2.png": "8c9e",
	"./child-avatar.png": "5002",
	"./child-avatar.svg": "f3ec",
	"./child_login.svg": "9cd7",
	"./circulo.svg": "d9e9",
	"./delete.svg": "d739",
	"./edit.svg": "6582",
	"./estrella_barra.svg": "753c",
	"./evaluations.svg": "a292",
	"./exit-system.png": "5991",
	"./flags/english.png": "dc3c",
	"./flags/spanish.png": "1ab9",
	"./fondo.svg": "4917",
	"./fondo_test_1.svg": "9bc2",
	"./fondo_test_2.svg": "ea6b",
	"./fondo_test_3.svg": "6842",
	"./fonts/Lato/generator_config.txt": "144f",
	"./fonts/Lato/lato-black-demo.html": "40a7",
	"./fonts/Lato/lato-black-webfont.ttf": "8b0e",
	"./fonts/Lato/lato-black-webfont.woff": "1b4f",
	"./fonts/Lato/lato-black-webfont.woff2": "5c4b",
	"./fonts/Lato/lato-blackitalic-demo.html": "ab6d",
	"./fonts/Lato/lato-blackitalic-webfont.ttf": "4ce7",
	"./fonts/Lato/lato-blackitalic-webfont.woff": "5abd",
	"./fonts/Lato/lato-blackitalic-webfont.woff2": "8113",
	"./fonts/Lato/lato-bold-demo.html": "819c",
	"./fonts/Lato/lato-bold-webfont.ttf": "8fd9",
	"./fonts/Lato/lato-bold-webfont.woff": "099e",
	"./fonts/Lato/lato-bold-webfont.woff2": "ad11",
	"./fonts/Lato/lato-bolditalic-demo.html": "5193",
	"./fonts/Lato/lato-bolditalic-webfont.woff": "495c",
	"./fonts/Lato/lato-bolditalic-webfont.woff2": "0de9",
	"./fonts/Lato/lato-hairline-demo.html": "a36d",
	"./fonts/Lato/lato-hairline-webfont.woff": "f1dd",
	"./fonts/Lato/lato-hairline-webfont.woff2": "33ba",
	"./fonts/Lato/lato-hairlineitalic-demo.html": "e517",
	"./fonts/Lato/lato-hairlineitalic-webfont.woff": "36fc",
	"./fonts/Lato/lato-hairlineitalic-webfont.woff2": "6e34",
	"./fonts/Lato/lato-italic-demo.html": "29f5",
	"./fonts/Lato/lato-italic-webfont.ttf": "c362",
	"./fonts/Lato/lato-italic-webfont.woff": "19b3",
	"./fonts/Lato/lato-italic-webfont.woff2": "ff0a",
	"./fonts/Lato/lato-light-demo.html": "29a4",
	"./fonts/Lato/lato-light-webfont.ttf": "1290",
	"./fonts/Lato/lato-light-webfont.woff": "92ea",
	"./fonts/Lato/lato-light-webfont.woff2": "7404",
	"./fonts/Lato/lato-lightitalic-demo.html": "12b4",
	"./fonts/Lato/lato-lightitalic-webfont.woff": "39c7",
	"./fonts/Lato/lato-lightitalic-webfont.woff2": "9e4d",
	"./fonts/Lato/lato-regular-demo.html": "4a3d",
	"./fonts/Lato/lato-regular-webfont.woff": "6660",
	"./fonts/Lato/lato-regular-webfont.woff2": "f8b5",
	"./fonts/Lato/specimen_files/grid_12-825-55-15.css": "13ca",
	"./fonts/Lato/specimen_files/specimen_stylesheet.css": "679b",
	"./fonts/Lato/stylesheet.css": "77f6",
	"./fonts/Minecrafter.eot": "4919",
	"./fonts/Minecrafter.svg": "a1e1",
	"./fonts/Minecrafter.ttf": "beeb",
	"./fonts/Minecrafter.woff": "e768",
	"./fonts/Rimouski.eot": "d0d7",
	"./fonts/Rimouski.woff2": "e48f",
	"./fonts/RimouskiSb-Regular.svg": "fa28",
	"./fonts/RimouskiSb-Regular.ttf": "8597",
	"./fonts/RimouskiSb-Regular.woff": "b6c2",
	"./fonts/Splatch.eot": "3c39",
	"./fonts/Splatch.svg": "380e",
	"./fonts/Splatch.ttf": "cc158",
	"./fonts/Splatch.woff": "c23f",
	"./fonts/THIS_FONT_IS_BOLD.eot": "2df1",
	"./fonts/THIS_FONT_IS_BOLD.svg": "31ac",
	"./fonts/THIS_FONT_IS_BOLD.ttf": "6940",
	"./fonts/THIS_FONT_IS_BOLD.woff": "83e0",
	"./fonts/TheBoldFont.eot": "bd60",
	"./fonts/TheBoldFont.svg": "81f3",
	"./fonts/TheBoldFont.ttf": "d61d",
	"./fonts/TheBoldFont.woff": "e54c",
	"./fonts/VCROSDMono.eot": "46d8",
	"./fonts/VCROSDMono.svg": "26a7",
	"./fonts/VCROSDMono.ttf": "a1cf",
	"./fonts/VCROSDMono.woff": "1934",
	"./fonts/VanillaExtractRegular.eot": "e2c2",
	"./fonts/VanillaExtractRegular.svg": "41b5",
	"./fonts/VanillaExtractRegular.ttf": "287b",
	"./fonts/VanillaExtractRegular.woff": "2acd",
	"./fonts/Varela_Round/generator_config.txt": "e52a",
	"./fonts/Varela_Round/specimen_files/grid_12-825-55-15.css": "e832",
	"./fonts/Varela_Round/specimen_files/specimen_stylesheet.css": "e6ba",
	"./fonts/Varela_Round/stylesheet.css": "8dec",
	"./fonts/Varela_Round/varelaround-regular-demo.html": "d74d",
	"./fonts/Varela_Round/varelaround-regular-webfont.ttf": "9f07",
	"./fonts/Varela_Round/varelaround-regular-webfont.woff": "a734",
	"./fonts/Varela_Round/varelaround-regular-webfont.woff2": "9278",
	"./fonts/Young-Italic.eot": "4994",
	"./fonts/Young-Italic.svg": "cff5",
	"./fonts/Young-Italic.ttf": "d2ed",
	"./fonts/Young-Italic.woff": "82e1",
	"./fonts/Young.eot": "bf5c",
	"./fonts/Young.svg": "9cc1",
	"./fonts/Young.ttf": "a0cb",
	"./fonts/Young.woff": "2e96",
	"./fonts/atma/hinted-Atma-Bold.ttf": "8f7f",
	"./fonts/atma/hinted-Atma-Light.ttf": "d3ca",
	"./fonts/atma/hinted-Atma-Medium.ttf": "a06d",
	"./fonts/atma/hinted-Atma-Regular.ttf": "b640",
	"./fonts/atma/hinted-Atma-SemiBold.ttf": "fa2c",
	"./fonts/atma/stylesheet.css": "ba90",
	"./fonts/comfortaa/comfortaa-bold-demo.html": "d93d",
	"./fonts/comfortaa/comfortaa-bold-webfont.woff": "909c",
	"./fonts/comfortaa/comfortaa-bold-webfont.woff2": "2209",
	"./fonts/comfortaa/comfortaa-light-demo.html": "7248",
	"./fonts/comfortaa/comfortaa-light-webfont.ttf": "5820",
	"./fonts/comfortaa/comfortaa-light-webfont.woff": "af47",
	"./fonts/comfortaa/comfortaa-light-webfont.woff2": "5cbb1",
	"./fonts/comfortaa/comfortaa-regular-demo.html": "dab5",
	"./fonts/comfortaa/comfortaa-regular-webfont.ttf": "b370",
	"./fonts/comfortaa/comfortaa-regular-webfont.woff": "1295",
	"./fonts/comfortaa/comfortaa-regular-webfont.woff2": "2dde",
	"./fonts/comfortaa/generator_config.txt": "2888",
	"./fonts/comfortaa/specimen_files/grid_12-825-55-15.css": "4029",
	"./fonts/comfortaa/specimen_files/specimen_stylesheet.css": "2698",
	"./fonts/comfortaa/stylesheet.css": "56fa",
	"./fonts/futura/FuturaNowText-Bd.ttf": "0d03",
	"./fonts/futura/FuturaNowText-Rg.ttf": "a0b3",
	"./fonts/futura/stylesheet.css": "aa54",
	"./fonts/roboto_mono/RobotoMono-Bold.woff": "fe8b",
	"./fonts/roboto_mono/RobotoMono-Bold.woff2": "8efd",
	"./fonts/roboto_mono/RobotoMono-BoldItalic.woff": "7e9f",
	"./fonts/roboto_mono/RobotoMono-BoldItalic.woff2": "5532",
	"./fonts/roboto_mono/RobotoMono-Italic.woff": "e9d3",
	"./fonts/roboto_mono/RobotoMono-Italic.woff2": "8cee",
	"./fonts/roboto_mono/RobotoMono-Light.woff": "8bcc",
	"./fonts/roboto_mono/RobotoMono-Light.woff2": "c589",
	"./fonts/roboto_mono/RobotoMono-LightItalic.woff": "ee3f",
	"./fonts/roboto_mono/RobotoMono-LightItalic.woff2": "40fc",
	"./fonts/roboto_mono/RobotoMono-Medium.woff": "6e62",
	"./fonts/roboto_mono/RobotoMono-Medium.woff2": "1095",
	"./fonts/roboto_mono/RobotoMono-MediumItalic.woff": "eaf8",
	"./fonts/roboto_mono/RobotoMono-MediumItalic.woff2": "497f",
	"./fonts/roboto_mono/RobotoMono-Regular.woff": "942b",
	"./fonts/roboto_mono/RobotoMono-Regular.woff2": "752a",
	"./fonts/roboto_mono/RobotoMono-Thin.woff": "e3f5",
	"./fonts/roboto_mono/RobotoMono-Thin.woff2": "c873",
	"./fonts/roboto_mono/RobotoMono-ThinItalic.woff": "1817",
	"./fonts/roboto_mono/RobotoMono-ThinItalic.woff2": "54d2",
	"./fonts/roboto_mono/demo.html": "33ae",
	"./fonts/roboto_mono/stylesheet.css": "00a4",
	"./fullscreen-24px.svg": "8482",
	"./fullscreen_exit-24px.svg": "0633",
	"./grades_name/en/icono_G1_ing.svg": "d392",
	"./grades_name/en/icono_G2_ing.svg": "2440",
	"./grades_name/en/icono_G3.svg": "5417",
	"./grades_name/en/icono_G4.svg": "ce1b",
	"./grades_name/en/icono_G5.svg": "c01f",
	"./grades_name/en/icono_G6.svg": "8366",
	"./grades_name/en/icono_G7.svg": "e87a",
	"./grades_name/en/icono_G8.svg": "73f7",
	"./grades_name/en/icono_k.svg": "74b5",
	"./grades_name/en/icono_pk.svg": "3bc2",
	"./grades_name/es/icono_G1_esp.svg": "c748",
	"./grades_name/es/icono_G2_esp.svg": "c656",
	"./grades_name/es/icono_G3.svg": "c9ba",
	"./grades_name/es/icono_G4.svg": "f551",
	"./grades_name/es/icono_G5.svg": "d03f",
	"./grades_name/es/icono_G6.svg": "3c5d",
	"./grades_name/es/icono_G7.svg": "6824",
	"./grades_name/es/icono_G8.svg": "56b9",
	"./help/demo.png": "ee19",
	"./help/email.png": "d48b",
	"./help/garantia.png": "317a",
	"./help/logo_TPM.png": "14cf",
	"./help/manual.png": "0f4b",
	"./help/suport.png": "fff8",
	"./history.svg": "76e0",
	"./hmp-logo.png": "cd21",
	"./home/halloween/image1.svg": "16bd",
	"./home/halloween/image10.svg": "54180",
	"./home/halloween/image11.svg": "6c87",
	"./home/halloween/image12.svg": "9ade",
	"./home/halloween/image13.svg": "39d1",
	"./home/halloween/image14.svg": "4abd",
	"./home/halloween/image15.svg": "3703",
	"./home/halloween/image16.svg": "e944",
	"./home/halloween/image17.svg": "16f4",
	"./home/halloween/image18.svg": "38b3",
	"./home/halloween/image19.svg": "d37d",
	"./home/halloween/image2.svg": "7fd4",
	"./home/halloween/image20.svg": "bda9",
	"./home/halloween/image21.svg": "9078",
	"./home/halloween/image3.svg": "6e8c",
	"./home/halloween/image4.svg": "8ef7",
	"./home/halloween/image5.svg": "a5db",
	"./home/halloween/image6.svg": "218a",
	"./home/halloween/image7.svg": "b18c",
	"./home/halloween/image8.svg": "5583",
	"./home/halloween/image9.svg": "e2ce",
	"./homeandmedia.svg": "14b4",
	"./ic_close_white_24dp_1x.png": "767d",
	"./ic_star_half_24px.svg": "7a9c",
	"./icon_practices.svg": "fe2c",
	"./icons-03.svg": "ae49",
	"./icons/Asset 37.png": "d388",
	"./icons/Asset 37.svg": "0de1",
	"./icons/Asset_28_right.png": "94fa",
	"./icons/Slice_1.png": "f1ce",
	"./icons/TESTicon.png": "bb07",
	"./icons/chevronDown.png": "b9da",
	"./icons/download_icon_blue.png": "2217",
	"./icons/exit-icon.png": "975d",
	"./icons/exit1.png": "aee4",
	"./icons/expand-window.gif": "7ec9",
	"./icons/glossary-icon.png": "5ccc",
	"./icons/highSchool/American_History.svg": "cd2f",
	"./icons/highSchool/Analytic_geometry.svg": "0052",
	"./icons/highSchool/Barra_2.svg": "5747",
	"./icons/highSchool/Biology.svg": "f17e",
	"./icons/highSchool/Calculus.svg": "700f",
	"./icons/highSchool/Chemistry.svg": "ba88",
	"./icons/highSchool/Diferential_calculus.svg": "4d39",
	"./icons/highSchool/English_1.svg": "02e7",
	"./icons/highSchool/English_2.svg": "85df",
	"./icons/highSchool/English_3.svg": "bf3e",
	"./icons/highSchool/English_4.svg": "95da",
	"./icons/highSchool/Geometry.svg": "5756",
	"./icons/highSchool/Government_economy.svg": "9d86",
	"./icons/highSchool/Mathematical_logic.svg": "3a5e",
	"./icons/highSchool/Trigonometry.svg": "af33",
	"./icons/highSchool/U_S_studies.svg": "4ba5",
	"./icons/highSchool/World_studies.svg": "b087",
	"./icons/highSchool/algebra_1.svg": "32ba",
	"./icons/highSchool/algebra_2.svg": "902b",
	"./icons/highSchool/arithmetic.svg": "1436",
	"./icons/highSchool/integral_calculus.svg": "dbac",
	"./icons/highSchool/physics.svg": "0ab7",
	"./icons/ic_arrow_back_48px_white.svg": "9e8f",
	"./icons/ic_clear_24px_white.svg": "e1f5",
	"./icons/ic_search_black_24px.svg": "18ee",
	"./icons/ic_search_black_48px.svg": "87f8",
	"./icons/ic_settings_48px_99a0b4ff.svg": "6a03",
	"./icons/ic_star_24px.svg": "3867",
	"./icons/ic_star_24px_#B3FF00.svg": "5977",
	"./icons/ic_star_border_24px.svg": "a77e",
	"./icons/ic_star_border_24px_#B3FF00.svg": "076c",
	"./icons/ic_star_border_24px_yellow.svg": "64b7",
	"./icons/ic_star_half_24px.svg": "b3d4",
	"./icons/ic_star_half_24px_#B3FF00.svg": "2564",
	"./icons/icon_www.svg": "05cf",
	"./icons/list-icon.png": "74fc",
	"./icons/lock_step1_open.png": "c30a",
	"./icons/logOutWhite.svg": "9c50",
	"./icons/logo hmp vert movil.png": "eb11",
	"./icons/lowerElementarySchool/iconos_grado_1/Icon12_05.svg": "fe21",
	"./icons/lowerElementarySchool/iconos_grado_1/Icon12_06.svg": "ff7f",
	"./icons/lowerElementarySchool/iconos_grado_1/Icon12_07.svg": "3792",
	"./icons/lowerElementarySchool/iconos_grado_1/Icon12_08.svg": "a0a4",
	"./icons/lowerElementarySchool/iconos_grado_1/Icon12_09.svg": "37e0",
	"./icons/lowerElementarySchool/iconos_grado_1/Icon12_math.svg": "4713",
	"./icons/lowerElementarySchool/iconos_grado_2/Icon12-10.svg": "3914",
	"./icons/lowerElementarySchool/iconos_grado_2/Icon12-11.svg": "f5ac",
	"./icons/lowerElementarySchool/iconos_grado_2/Icon12-12.svg": "33d9",
	"./icons/lowerElementarySchool/iconos_grado_2/Icon12-13.svg": "0695",
	"./icons/lowerElementarySchool/iconos_grado_2/Icon12-14.svg": "c4a1",
	"./icons/lowerElementarySchool/iconos_grado_2/Icon12-15.svg": "fae2",
	"./icons/lupa.svg": "fe80",
	"./icons/menu/Boton_Worksheets.svg": "3065",
	"./icons/menu/books.png": "37ab",
	"./icons/menu/dictionary.svg": "b31e",
	"./icons/menu/home.png": "32f0",
	"./icons/menu/info.svg": "22d8",
	"./icons/menu/language.png": "868a",
	"./icons/menu/laptop-computer.svg": "4d62",
	"./icons/menu/logout.png": "3d64",
	"./icons/menu/lupa.png": "34e6",
	"./icons/menu/new_menu_icons/Boton_Home.svg": "ed07",
	"./icons/menu/new_menu_icons/Boton_Practices.svg": "1b7c",
	"./icons/menu/new_menu_icons/Boton_dictionary.svg": "e4eb",
	"./icons/menu/new_menu_icons/Boton_e-library.svg": "ffb6",
	"./icons/menu/new_menu_icons/Boton_help.svg": "8f61",
	"./icons/menu/new_menu_icons/Boton_language.svg": "332e",
	"./icons/menu/new_menu_icons/Botón de búsqueda.svg": "b118",
	"./icons/menu/new_menu_icons/Sign_out_icono.svg": "6bcd",
	"./icons/menu/new_menu_icons/iconosHighSchool/206465A7.png": "fcbf",
	"./icons/menu/new_menu_icons/iconosHighSchool/4B5055E2.png": "527c",
	"./icons/menu/new_menu_icons/iconosHighSchool/5C511D5.png": "245e",
	"./icons/menu/new_menu_icons/iconosHighSchool/77B32350.png": "506f",
	"./icons/menu/new_menu_icons/iconosHighSchool/80E3A8D5.png": "4e5f",
	"./icons/menu/new_menu_icons/iconosHighSchool/8B22A79F.png": "d4a2",
	"./icons/menu/new_menu_icons/iconosHighSchool/Boton busqueda.svg": "04a7",
	"./icons/menu/new_menu_icons/iconosHighSchool/Boton cerrar.svg": "47b3",
	"./icons/menu/new_menu_icons/iconosHighSchool/Boton_Worksheets.svg": "d6e3",
	"./icons/menu/new_menu_icons/iconosHighSchool/Boton_sign_out.svg": "2841",
	"./icons/menu/new_menu_icons/iconosHighSchool/ECCBA3E3.png": "9cd4",
	"./icons/menu/new_menu_icons/iconosHighSchool/Fondo.svg": "c336",
	"./icons/menu/new_menu_icons/iconosHighSchool/Foto.svg": "4c1e",
	"./icons/menu/new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/206465A7.png": "ecb5",
	"./icons/menu/new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/4B5055E2.png": "3d12",
	"./icons/menu/new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/5C511D5.png": "c515",
	"./icons/menu/new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/77B32350.png": "9a11",
	"./icons/menu/new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/80E3A8D5.png": "de0c",
	"./icons/menu/new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/8B22A79F.png": "ccbe",
	"./icons/menu/new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_dictionary.svg": "e249",
	"./icons/menu/new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_help.svg": "3721",
	"./icons/menu/new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_home.svg": "11be",
	"./icons/menu/new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_language.svg": "ff33",
	"./icons/menu/new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_library.svg": "1402",
	"./icons/menu/new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/Boton_practice.svg": "90d3",
	"./icons/menu/new_menu_icons/iconosHighSchool/MD_HIGH SCHOOL/ECCBA3E3.png": "3a3d",
	"./icons/menu/new_menu_icons/iconosHighSchool/barra busqueda.svg": "217d",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/Dictionary.svg": "c138",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/Help.svg": "4553",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/Home.svg": "213f",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/Language.svg": "75cc",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/MLms-02.svg": "55ec",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/MLms-03.svg": "90d5",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/MLms-04.svg": "7322",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/MLms-05.svg": "849b",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/MLms-06.svg": "4c41",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/MLms-07.svg": "c171",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/MLms-08.svg": "9a31",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/MLms-09.svg": "fc21",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/MLms-10.svg": "ab79",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/MLms-11.svg": "246b",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/MLms-12.svg": "239a1",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/MLms-13.svg": "27d2",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/Prectice.svg": "9c56",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/avatarMLms_01.svg": "eb52",
	"./icons/menu/new_menu_icons/iconosMiddleSchool/e-library.svg": "1da13",
	"./icons/menu/play.png": "5c23",
	"./icons/menu/settings.svg": "a6d2",
	"./icons/menu/tutor/Icon_menu_1.svg": "ea0a",
	"./icons/menu/tutor/Icon_menu_2.svg": "3db3",
	"./icons/menu/tutor/Icon_menu_3.svg": "1cda",
	"./icons/menu/tutor/Icon_menu_4.svg": "4ed5",
	"./icons/menu/tutor/Icon_menu_5.svg": "0bab",
	"./icons/menu/tutor/Icon_menu_6.svg": "78bd",
	"./icons/menu/tutor/Icon_menu_logout.svg": "dd8b",
	"./icons/menu/tutor/Icon_menu_logout_Hover.svg": "7c5d",
	"./icons/menu/users.svg": "0731",
	"./icons/menu/windows_control/Close_1.svg": "be4a",
	"./icons/menu/windows_control/Close_2.svg": "027d",
	"./icons/menu/windows_control/maximize_1.svg": "a3dc",
	"./icons/menu/windows_control/maximize_2.svg": "9517",
	"./icons/menu/windows_control/minimize_1.svg": "4b35",
	"./icons/menu/windows_control/minimize_2.svg": "1504",
	"./icons/middleSchool/Barra_3.svg": "f4d7",
	"./icons/middleSchool/Iconos_grado_6/Grammar_6.svg": "4460",
	"./icons/middleSchool/Iconos_grado_6/Math_6.svg": "f06b",
	"./icons/middleSchool/Iconos_grado_6/Reading_6.svg": "9565",
	"./icons/middleSchool/Iconos_grado_6/Science_6.svg": "2011",
	"./icons/middleSchool/Iconos_grado_6/Social_Studies_6.svg": "f363",
	"./icons/middleSchool/Iconos_grado_6/Vocabulary_6.svg": "d18d",
	"./icons/middleSchool/Iconos_grado_7/Grammar_7.svg": "419d",
	"./icons/middleSchool/Iconos_grado_7/Math_7.svg": "60c6",
	"./icons/middleSchool/Iconos_grado_7/Reading_7.svg": "b755",
	"./icons/middleSchool/Iconos_grado_7/Science_7.svg": "afeb",
	"./icons/middleSchool/Iconos_grado_7/Social_studies_7.svg": "4b85",
	"./icons/middleSchool/Iconos_grado_7/Vocabulary_7.svg": "818c",
	"./icons/middleSchool/Iconos_grado_8/Grammar_8.svg": "515a",
	"./icons/middleSchool/Iconos_grado_8/Math_8.svg": "80eb",
	"./icons/middleSchool/Iconos_grado_8/Reading_8.svg": "b7a6",
	"./icons/middleSchool/Iconos_grado_8/Science_8.svg": "bb15",
	"./icons/middleSchool/Iconos_grado_8/Social_studies_8.svg": "f5ab",
	"./icons/middleSchool/Iconos_grado_8/Vocabulary_8.svg": "e89f",
	"./icons/nextPurpleB.png": "8fab",
	"./icons/next_blue.png": "796e",
	"./icons/next_purple.png": "f818",
	"./icons/pause.png": "df2a",
	"./icons/phone.png": "7f32",
	"./icons/phone.svg": "c3bb",
	"./icons/play.png": "1131",
	"./icons/print.png": "a4a5",
	"./icons/question-list.png": "558b",
	"./icons/size.png": "6230",
	"./icons/stop.png": "02e6",
	"./icons/subjects/icono_arts_language.svg": "3f24",
	"./icons/subjects/icono_math.svg": "35a4",
	"./icons/subjects/icono_science.svg": "19ca",
	"./icons/subjects/icono_social_studies.svg": "5802",
	"./icons/upperElementarySchool/iconos_grado_3/Grammar_3.svg": "b9b7",
	"./icons/upperElementarySchool/iconos_grado_3/Reading_3.svg": "a9f3",
	"./icons/upperElementarySchool/iconos_grado_3/Science_3.svg": "6392",
	"./icons/upperElementarySchool/iconos_grado_3/Social_Studies_3.svg": "783f",
	"./icons/upperElementarySchool/iconos_grado_3/Vocabulary_3.svg": "7cd2",
	"./icons/upperElementarySchool/iconos_grado_3/math_3.svg": "26d3",
	"./icons/upperElementarySchool/iconos_grado_4/Grammar_4.svg": "6773",
	"./icons/upperElementarySchool/iconos_grado_4/Math_4.svg": "fc2f",
	"./icons/upperElementarySchool/iconos_grado_4/Reading_4.svg": "efff",
	"./icons/upperElementarySchool/iconos_grado_4/Science_4.svg": "ce49",
	"./icons/upperElementarySchool/iconos_grado_4/Social_studies_4.svg": "f3a8",
	"./icons/upperElementarySchool/iconos_grado_4/Vocabulary_4.svg": "51b4",
	"./icons/upperElementarySchool/iconos_grado_5/Grammar_5.svg": "5fdd",
	"./icons/upperElementarySchool/iconos_grado_5/Math_5.svg": "c6c2",
	"./icons/upperElementarySchool/iconos_grado_5/Reading_5.svg": "7ac7",
	"./icons/upperElementarySchool/iconos_grado_5/Science_5.svg": "4fd1",
	"./icons/upperElementarySchool/iconos_grado_5/Social_studies_5.svg": "3fe0",
	"./icons/upperElementarySchool/iconos_grado_5/Vocabulary_5.svg": "a071",
	"./icons/user-icon.png": "3459",
	"./icons/view_icon_blue.png": "a69d",
	"./icons/volume.png": "3481",
	"./images/1-5/a+.png": "a868",
	"./images/1-5/a-.png": "6b95",
	"./images/1-5/a.png": "72f2",
	"./images/1-5/b+.png": "b396",
	"./images/1-5/b-.png": "aace",
	"./images/1-5/b.png": "bf7c",
	"./images/1-5/c+.png": "3bb9",
	"./images/1-5/c-.png": "53c8",
	"./images/1-5/c.png": "aa1c",
	"./images/1-5/d+.png": "1764",
	"./images/1-5/d-.png": "252c",
	"./images/1-5/d.png": "2269",
	"./images/1-5/f.png": "d489",
	"./images/1st-grade-en.png": "8a52",
	"./images/2nd-grade-en.png": "4f08",
	"./images/3rd-grade-en.png": "0620",
	"./images/4th-grade-en.png": "1f76",
	"./images/5th-grade-en.png": "a6d6",
	"./images/6-12/a+.png": "106c",
	"./images/6-12/a-.png": "d529",
	"./images/6-12/a.png": "2198",
	"./images/6-12/b+.png": "9da5",
	"./images/6-12/b-.png": "413d",
	"./images/6-12/b.png": "17b5",
	"./images/6-12/c+.png": "0346",
	"./images/6-12/c-.png": "87b8",
	"./images/6-12/c.png": "664d",
	"./images/6-12/d+.png": "bf12",
	"./images/6-12/d-.png": "936c",
	"./images/6-12/d.png": "0f97",
	"./images/6-12/f.png": "4dc2",
	"./images/6th-grade-en.png": "7016",
	"./images/7th-grade-en.png": "8840c",
	"./images/8th-grade-en.png": "1ed7",
	"./images/algebra1.png": "fe08",
	"./images/algebra2.png": "001a",
	"./images/analytic-geometry.png": "5381",
	"./images/arihmetic.png": "43d3",
	"./images/background-main.png": "ca32",
	"./images/background.png": "9855",
	"./images/calculus.png": "b949",
	"./images/differential-calculus.png": "8863",
	"./images/elementary-school-en.png": "9789",
	"./images/english1.png": "952a",
	"./images/english2.png": "82ec",
	"./images/english3.png": "ac65",
	"./images/english4.png": "ce64",
	"./images/fondo_new.svg": "fac5",
	"./images/geometry.png": "3d61",
	"./images/government-economy.png": "7d30",
	"./images/grammar-1-en.png": "7158",
	"./images/grammar-2-en.png": "6842e",
	"./images/grammar-3-en.png": "eb64",
	"./images/grammar-4-en.png": "d285",
	"./images/grammar-5-en.png": "2791",
	"./images/grammar-6-en.png": "618d",
	"./images/grammar-7-en.png": "1fb8",
	"./images/grammar-8-en.png": "1992",
	"./images/high-school-en.png": "9b21",
	"./images/high-school-grade-en.png": "0981",
	"./images/icon-tpm.png": "ae74",
	"./images/integral-calculus.png": "f837",
	"./images/kindergarten-grade-en.png": "caa2",
	"./images/logo-tpm.png": "a0ef",
	"./images/math-1-en.png": "006a",
	"./images/math-2-en.png": "802d",
	"./images/math-3-en.png": "d78b",
	"./images/math-4-en.png": "ea8f",
	"./images/math-5-en.png": "f4ea",
	"./images/math-6-en.png": "dcf5",
	"./images/math-7-en.png": "654d",
	"./images/math-8-en.png": "8de5",
	"./images/mathematical-logic.png": "25d9",
	"./images/middle-school-en.png": "43f6",
	"./images/preschool-en.png": "0aec",
	"./images/preschool-grade-en.png": "c8f9",
	"./images/reading-1-en.png": "59eb",
	"./images/reading-2-en.png": "daca",
	"./images/reading-3-en.png": "1eeb",
	"./images/reading-4-en.png": "8555",
	"./images/reading-5-en.png": "a2c1",
	"./images/reading-6-en.png": "7ee9",
	"./images/reading-7-en.png": "cb9c",
	"./images/reading-8-en.png": "bee7",
	"./images/science-1-en.png": "558e",
	"./images/science-2-en.png": "3e83",
	"./images/science-3-en.png": "37ed",
	"./images/science-4-en.png": "d987",
	"./images/science-5-en.png": "db292",
	"./images/science-6-en.png": "ee32",
	"./images/social-studies-1-en.png": "93ee",
	"./images/social-studies-2-en.png": "8d1e",
	"./images/social-studies-3-en.png": "5174",
	"./images/social-studies-4-en.png": "3908",
	"./images/social-studies-5-en.png": "05b2",
	"./images/social-studies-6-en.png": "6fc0",
	"./images/social-studies-7-en.png": "7c5c",
	"./images/social-studies-8-en.png": "e376",
	"./images/trigonometry.png": "8cfc",
	"./images/vocabulary-1-en.png": "b2b2",
	"./images/vocabulary-2-en.png": "131d",
	"./images/vocabulary-3-en.png": "4ebd",
	"./images/vocabulary-4-en.png": "ea0b",
	"./images/vocabulary-5-en.png": "5984",
	"./images/vocabulary-6-en.png": "e60d",
	"./images/vocabulary-7-en.png": "8786",
	"./images/vocabulary-8-en.png": "4220",
	"./img-carousel-1.jpeg": "e6fc",
	"./img-carousel-2.jpeg": "3b6d",
	"./img-carousel-3.jpeg": "b33f",
	"./img-carousel-4.jpeg": "2feb",
	"./img/BK-alfa2.png": "63e4",
	"./img/arrowNextBook-right.png": "8927",
	"./img/arrowNextBook.png": "0047",
	"./img/arrowNextBook2.png": "ca49",
	"./img/backWhiteB.png": "5089",
	"./img/background-books.png": "a2b9",
	"./img/ballon.png": "7606",
	"./img/border.png": "4455",
	"./img/brain1.png": "7bae",
	"./img/bubllee4.png": "69090",
	"./img/checkmark.png": "b602",
	"./img/close.png": "04b3",
	"./img/dobleArrow.png": "0a26",
	"./img/dobleArrowFlip.png": "8eec",
	"./img/globo3.png": "2e1f",
	"./img/globoo.png": "1528",
	"./img/ic_chevron_left_black_48px.svg": "c8d3",
	"./img/ic_chevron_right_black_48px.svg": "0581",
	"./img/ic_chevron_right_white_48px.svg": "0985",
	"./img/ic_clear_white_24px.svg": "c13b",
	"./img/ic_menu_white_24px.svg": "623c",
	"./img/icon5.png": "c70d",
	"./img/iconQUIZ.png": "df4f",
	"./img/img_student.png": "36fc3",
	"./img/img_tutor.png": "7774",
	"./img/logo HMP.png": "128d",
	"./img/navigation-left.png": "1d25",
	"./img/navigation-right.png": "b5b6",
	"./img/next.png": "0601",
	"./img/nextPurpleB.png": "b364",
	"./img/nextWhiteB.png": "ec75",
	"./img/quizz3.png": "db43",
	"./img/quizz6.png": "0c61",
	"./img/reload.png": "7b3d",
	"./img/right.png": "d2ff",
	"./img/score-percent.png": "8416",
	"./img/star_border_grey.png": "0645",
	"./img/star_border_grey.svg": "f9cd",
	"./img/star_rate_yellow.png": "8ef2",
	"./img/star_rate_yellow.svg": "dfd1",
	"./img/wrong.png": "43d7",
	"./lapiz-tpm.svg": "07b2",
	"./learning-mentor-avatar.png": "fec3",
	"./learning-mentor-avatar.svg": "f293",
	"./levels_names/en/GED_Practice.svg": "ce84",
	"./levels_names/en/High_School.svg": "868b",
	"./levels_names/en/Lower_Elementary_School.svg": "dc52",
	"./levels_names/en/Middle_school.svg": "8ead",
	"./levels_names/en/SAT_Practice.svg": "333b",
	"./levels_names/en/State_test_Practice.svg": "c57e",
	"./levels_names/en/Upper_Elementary_School.svg": "a25f",
	"./levels_names/es/Escuela_primaria.svg": "5e3e",
	"./levels_names/es/Escuela_primaria_inferior.svg": "f7e3",
	"./levels_names/es/Escuela_secundaria.svg": "4c34",
	"./levels_names/es/Secundaria.svg": "3bdd",
	"./license-sticker.png": "6b93",
	"./login/email-login.png": "8049",
	"./login/email-login2.png": "b677",
	"./login/image1.png": "4e2f",
	"./login/image10.svg": "0cb5",
	"./login/image11.svg": "4e0f",
	"./login/image12.svg": "1e9c",
	"./login/image13.svg": "97ab",
	"./login/image14.svg": "4e09",
	"./login/image15.svg": "2876",
	"./login/image16.svg": "0a1c",
	"./login/image17.svg": "a033",
	"./login/image18.svg": "9576",
	"./login/image19.svg": "bd67",
	"./login/image2.png": "4bd5",
	"./login/image20.svg": "bc8e",
	"./login/image21.svg": "1256",
	"./login/image22.svg": "f814",
	"./login/image23.svg": "54fd",
	"./login/image3.svg": "cf2a",
	"./login/image4.svg": "af42",
	"./login/image5.svg": "cdeb",
	"./login/image6.svg": "55fb",
	"./login/image7.png": "4dad",
	"./login/image8.svg": "0565",
	"./login/image9.svg": "e93e",
	"./login/password.png": "4089",
	"./login/password1.png": "0e23",
	"./login/password2.jpg": "aa12",
	"./login/user-login.png": "889c",
	"./login/user-login1.png": "d48a",
	"./login/user-login2.png": "7a10",
	"./login/welcome.png": "ad65",
	"./logo mytpmschool.png": "2a8a",
	"./logo.png": "cf05",
	"./logoStrokeWhite.png": "1cad",
	"./logoTPMblack.svg": "8be4",
	"./logo_bbb.svg": "1488",
	"./logout.svg": "309a",
	"./maximize-system.png": "de06",
	"./minimize-system.png": "8fb3",
	"./nivel0.png": "d498",
	"./nivel1.png": "b829",
	"./nivel2.png": "1924",
	"./nivel3.png": "4b10",
	"./overlay_landscape.svg": "ac1d",
	"./parent-avatar.png": "0156",
	"./parent-avatar.svg": "5010",
	"./parent_login.svg": "9083",
	"./people_dummy.png": "e09f",
	"./practices.svg": "fcc0",
	"./practices/clown_to_water/background.svg": "d7c1",
	"./practices/clown_to_water/button_start.svg": "913a",
	"./practices/clown_to_water/drop_left.svg": "ed8f",
	"./practices/clown_to_water/drop_right.svg": "cce0",
	"./practices/data/easter_egg/assets": "da08",
	"./practices/data/easter_egg/assets.json": "da08",
	"./practices/data/easter_egg/questions": "9bf5",
	"./practices/data/easter_egg/questions.json": "9bf5",
	"./practices/data/expanded_form/exercises": "6610",
	"./practices/data/expanded_form/exercises.json": "6610",
	"./practices/data/fishy_problems/exercises": "5b11",
	"./practices/data/fishy_problems/exercises.json": "5b11",
	"./practices/data/pet_life/exercises": "4c3c",
	"./practices/data/pet_life/exercises.json": "4c3c",
	"./practices/data/pumpkin_clock/exercises": "e1a6",
	"./practices/data/pumpkin_clock/exercises.json": "e1a6",
	"./practices/data/saving_money/exercises": "47f2",
	"./practices/data/saving_money/exercises.json": "47f2",
	"./practices/data/soccer_goal/exercises": "7005",
	"./practices/data/soccer_goal/exercises.json": "7005",
	"./practices/easter_egg/avatar_image_bg.svg": "445b",
	"./practices/easter_egg/avatar_level.svg": "3a35",
	"./practices/easter_egg/avatar_name.svg": "2b0b",
	"./practices/easter_egg/avatar_progress.svg": "175e",
	"./practices/easter_egg/background_field.svg": "378d",
	"./practices/easter_egg/banner_blue.svg": "372c",
	"./practices/easter_egg/banner_correct.svg": "c53d",
	"./practices/easter_egg/banner_correct_text.svg": "5a2d",
	"./practices/easter_egg/banner_home_left.svg": "c62d",
	"./practices/easter_egg/banner_home_right.svg": "c322",
	"./practices/easter_egg/banner_incorrect.svg": "6763",
	"./practices/easter_egg/banner_incorrect_text.svg": "1c1e",
	"./practices/easter_egg/banner_orange.svg": "8956",
	"./practices/easter_egg/banner_points.svg": "d4d3",
	"./practices/easter_egg/banner_tail.svg": "6578",
	"./practices/easter_egg/bunny_sit.svg": "e94d",
	"./practices/easter_egg/bunny_string.svg": "4d37",
	"./practices/easter_egg/bunny_string_short.svg": "f599",
	"./practices/easter_egg/button_exit.svg": "7a0e",
	"./practices/easter_egg/button_settings.svg": "e456",
	"./practices/easter_egg/button_sound.svg": "beb1",
	"./practices/easter_egg/button_sound_muted.svg": "114b",
	"./practices/easter_egg/button_speech.svg": "dbc4",
	"./practices/easter_egg/button_speech_muted.svg": "3d21",
	"./practices/easter_egg/cloud.svg": "dd58",
	"./practices/easter_egg/cloud_medium.svg": "a8ac",
	"./practices/easter_egg/cloud_small.svg": "a621",
	"./practices/easter_egg/duck.svg": "09f5",
	"./practices/easter_egg/duck_dim.svg": "4f31",
	"./practices/easter_egg/egg_circles.svg": "e057",
	"./practices/easter_egg/egg_circles_happy.svg": "789d",
	"./practices/easter_egg/egg_circles_sad.svg": "e0f9",
	"./practices/easter_egg/egg_clouds.svg": "b527",
	"./practices/easter_egg/egg_clouds_happy.svg": "9bbc",
	"./practices/easter_egg/egg_clouds_sad.svg": "7665",
	"./practices/easter_egg/egg_crowns.svg": "236d",
	"./practices/easter_egg/egg_crowns_happy.svg": "209c",
	"./practices/easter_egg/egg_crowns_sad.svg": "432d",
	"./practices/easter_egg/egg_fish.svg": "628e",
	"./practices/easter_egg/egg_fish_happy.svg": "f87d",
	"./practices/easter_egg/egg_fish_sad.svg": "a29b",
	"./practices/easter_egg/egg_flowers.svg": "64ea",
	"./practices/easter_egg/egg_flowers_happy.svg": "0ad3",
	"./practices/easter_egg/egg_flowers_sad.svg": "ad0d",
	"./practices/easter_egg/egg_hearts.svg": "577f",
	"./practices/easter_egg/egg_hearts_happy.svg": "7057",
	"./practices/easter_egg/egg_hearts_sad.svg": "4867",
	"./practices/easter_egg/egg_melons.svg": "5ef7",
	"./practices/easter_egg/egg_melons_happy.svg": "f152",
	"./practices/easter_egg/egg_melons_sad.svg": "1e8a",
	"./practices/easter_egg/egg_planes.svg": "d13c",
	"./practices/easter_egg/egg_planes_happy.svg": "2761",
	"./practices/easter_egg/egg_planes_sad.svg": "1ffd",
	"./practices/easter_egg/egg_plant.svg": "07f4",
	"./practices/easter_egg/egg_plant_happy.svg": "dd60",
	"./practices/easter_egg/egg_plant_sad.svg": "1d67",
	"./practices/easter_egg/egg_spirals.svg": "edeb",
	"./practices/easter_egg/egg_spirals_happy.svg": "f4ec",
	"./practices/easter_egg/egg_spirals_sad.svg": "db51",
	"./practices/easter_egg/egg_squares.svg": "6b00",
	"./practices/easter_egg/egg_squares_happy.svg": "abd5",
	"./practices/easter_egg/egg_squares_sad.svg": "e64c",
	"./practices/easter_egg/egg_stars.svg": "25d6",
	"./practices/easter_egg/egg_stars_happy.svg": "8878",
	"./practices/easter_egg/egg_stars_sad.svg": "d96c",
	"./practices/easter_egg/flower.svg": "a493",
	"./practices/easter_egg/life.svg": "f21f",
	"./practices/easter_egg/life_dim.svg": "701c",
	"./practices/easter_egg/mute.svg": "ad8d",
	"./practices/easter_egg/paper_plane_solo.svg": "8483",
	"./practices/easter_egg/plane_correct.svg": "d5d2",
	"./practices/easter_egg/plane_incorrect.svg": "8777",
	"./practices/easter_egg/plane_orange.svg": "d8a9",
	"./practices/easter_egg/settings_background.svg": "cbb5",
	"./practices/easter_egg/speaker.svg": "48f5",
	"./practices/easter_egg/star.svg": "5b71",
	"./practices/easter_egg/star_dim.svg": "9c7f",
	"./practices/easter_egg/stroke_font.svg": "05ef",
	"./practices/expanded_form/OLD_egg_stars.svg": "3f2b",
	"./practices/expanded_form/OLD_egg_wind.svg": "e1e8",
	"./practices/expanded_form/OLDegg_flames.svg": "4d8f",
	"./practices/expanded_form/OLDegg_sparkles.svg": "7467",
	"./practices/expanded_form/background.svg": "fe6a",
	"./practices/expanded_form/background_mountains.svg": "4ee8",
	"./practices/expanded_form/background_sky.svg": "ab45",
	"./practices/expanded_form/egg_flames.svg": "6f6b",
	"./practices/expanded_form/egg_nest.svg": "83b7",
	"./practices/expanded_form/egg_sparkles.svg": "5418",
	"./practices/expanded_form/egg_stars.svg": "990f",
	"./practices/expanded_form/egg_wind.svg": "9d67",
	"./practices/expanded_form/life.svg": "a792",
	"./practices/expanded_form/life_dim.svg": "6734",
	"./practices/expanded_form/scroll_question.svg": "f98a",
	"./practices/expanded_form/scroll_score.svg": "6b51",
	"./practices/fishy_problems/feedback_correct.svg": "280e",
	"./practices/fishy_problems/feedback_incorrect.svg": "5939",
	"./practices/fishy_problems/fish_orange.svg": "b30a",
	"./practices/fishy_problems/fish_purple.svg": "4d1f",
	"./practices/fishy_problems/fish_red.svg": "4773",
	"./practices/fishy_problems/life.svg": "3c27",
	"./practices/fishy_problems/life_dim.svg": "f2b3",
	"./practices/global/avatar/avatar_image_bg.svg": "9988",
	"./practices/global/avatar/avatar_level.svg": "b24c",
	"./practices/global/avatar/avatar_name.svg": "ace8",
	"./practices/global/avatar/avatar_progress.svg": "fe07",
	"./practices/global/brand/hmp_logo_black.svg": "daec",
	"./practices/global/brand/hmp_logo_white.svg": "d8fc",
	"./practices/global/overlay_landscape.svg": "e3f9",
	"./practices/global/retry.svg": "464d",
	"./practices/global/settings/button_exit.svg": "c5d6",
	"./practices/global/settings/button_settings.svg": "912f",
	"./practices/global/settings/button_sound.svg": "d3f3",
	"./practices/global/settings/button_sound_muted.svg": "f66d",
	"./practices/global/settings/button_speech.svg": "3e78",
	"./practices/global/settings/button_speech_muted.svg": "86b6",
	"./practices/global/settings/settings_background.svg": "4f2b",
	"./practices/global/subject/math.svg": "a485",
	"./practices/home/background.png": "9ccf",
	"./practices/home/background.svg": "a5fa",
	"./practices/home/button_play.svg": "068f",
	"./practices/home/hero.svg": "fb8f",
	"./practices/home/logo.png": "b097",
	"./practices/home/logo_hmp.svg": "fd93",
	"./practices/home/preview_easter_egg.png": "c367",
	"./practices/home/preview_expanded_form.png": "9e07",
	"./practices/home/preview_fishy_problems.png": "e706",
	"./practices/home/preview_pet_life.png": "576b",
	"./practices/home/preview_pumpkin_clock.png": "dd60c",
	"./practices/home/preview_saving_money.png": "55e0",
	"./practices/home/preview_soccer_goal.png": "3c33",
	"./practices/home/styles/_fonts.scss": "65cc",
	"./practices/home/styles/_mixins.scss": "6bd7",
	"./practices/home/styles/main.scss": "9849",
	"./practices/pet_life/background.svg": "ce96",
	"./practices/pet_life/button_blue_bottom.svg": "cf47",
	"./practices/pet_life/button_blue_top.svg": "1752",
	"./practices/pet_life/button_green_bottom.svg": "aee3",
	"./practices/pet_life/button_green_top.svg": "6279",
	"./practices/pet_life/button_next_bottom_active.svg": "3363",
	"./practices/pet_life/button_next_bottom_inactive.svg": "6fb2",
	"./practices/pet_life/button_next_top_active.svg": "8117",
	"./practices/pet_life/button_next_top_inactive.svg": "2c31",
	"./practices/pet_life/foreground.svg": "b377",
	"./practices/pet_life/life.svg": "3bba",
	"./practices/pet_life/life_stroke.svg": "372a",
	"./practices/pumpkin_clock/background_home.svg": "89d5",
	"./practices/pumpkin_clock/background_instructions.svg": "b02b",
	"./practices/pumpkin_clock/background_main_game.png": "a8ed",
	"./practices/pumpkin_clock/background_main_game.svg": "239a",
	"./practices/pumpkin_clock/bubble_correct.svg": "5614",
	"./practices/pumpkin_clock/bubble_incorrect.svg": "fc18",
	"./practices/pumpkin_clock/cauldronActive.svg": "306b",
	"./practices/pumpkin_clock/cauldronInactive.svg": "b6aa",
	"./practices/pumpkin_clock/clock_test.png": "6d22",
	"./practices/pumpkin_clock/clocks/eight_fifty.svg": "46ee",
	"./practices/pumpkin_clock/clocks/eight_ten.svg": "8720",
	"./practices/pumpkin_clock/clocks/eleven_forty.svg": "c55a",
	"./practices/pumpkin_clock/clocks/five_twenty.svg": "0bba",
	"./practices/pumpkin_clock/clocks/four_ten.svg": "761a",
	"./practices/pumpkin_clock/clocks/nine_ten.svg": "cfd0",
	"./practices/pumpkin_clock/clocks/nine_thirty_five.svg": "f864",
	"./practices/pumpkin_clock/clocks/seven_fifty.svg": "3053",
	"./practices/pumpkin_clock/clocks/seven_o_clock.svg": "02f8",
	"./practices/pumpkin_clock/clocks/six_forty.svg": "c879",
	"./practices/pumpkin_clock/clocks/six_twenty_five.svg": "b8f5",
	"./practices/pumpkin_clock/clocks/three_forty_five.svg": "e312",
	"./practices/pumpkin_clock/clocks/three_thirty.svg": "6297",
	"./practices/pumpkin_clock/clocks/twelve_fifteen.svg": "23a5",
	"./practices/pumpkin_clock/clocks/two_five.svg": "04e9",
	"./practices/pumpkin_clock/house.png": "7eeb",
	"./practices/pumpkin_clock/mute.svg": "4c76",
	"./practices/pumpkin_clock/pumpkin.png": "c53c",
	"./practices/pumpkin_clock/pumpkin_happy.png": "03a0",
	"./practices/pumpkin_clock/pumpkin_sad.png": "efda",
	"./practices/pumpkin_clock/retry.svg": "2c08",
	"./practices/pumpkin_clock/speaker.svg": "01fe",
	"./practices/pumpkin_clock/stars_left.svg": "732c",
	"./practices/pumpkin_clock/stars_right.svg": "ad35",
	"./practices/pumpkin_clock/witch_avatar.svg": "e38a",
	"./practices/pumpkin_clock/witch_home.png": "b34d",
	"./practices/pumpkin_clock/z-other-witch_home.svg": "b7d3",
	"./practices/pumpkin_clock/z-other_Rectangle 5.svg": "86f9",
	"./practices/saving_money/button_clear.svg": "ef48",
	"./practices/saving_money/button_exit.svg": "99c8",
	"./practices/saving_money/button_next.svg": "8b36",
	"./practices/saving_money/button_next_game.svg": "4694",
	"./practices/saving_money/button_reload.svg": "dbe4",
	"./practices/saving_money/button_start.svg": "5655",
	"./practices/saving_money/button_submit.svg": "e691",
	"./practices/saving_money/coin_dime.svg": "1abe",
	"./practices/saving_money/coin_dimes.svg": "842d",
	"./practices/saving_money/coin_nickel.svg": "763b",
	"./practices/saving_money/coin_nickels.svg": "837b",
	"./practices/saving_money/coin_pennies.svg": "0c6e",
	"./practices/saving_money/coin_penny.svg": "c507",
	"./practices/saving_money/coin_quarter.svg": "bf34",
	"./practices/saving_money/coin_quarters.svg": "bf90",
	"./practices/saving_money/life.svg": "2395",
	"./practices/saving_money/life_dim.svg": "4953",
	"./practices/saving_money/pig_dime.svg": "c3c1",
	"./practices/saving_money/pig_nickel.svg": "4748",
	"./practices/saving_money/pig_penny.svg": "4752",
	"./practices/saving_money/pig_quarter.svg": "db21",
	"./practices/saving_money/sidebar_bubble.svg": "fb7d",
	"./practices/soccer_goal/bleachers_center.svg": "c4b0",
	"./practices/soccer_goal/bleachers_left.svg": "d00a",
	"./practices/soccer_goal/bleachers_right.svg": "cfd9",
	"./practices/soccer_goal/dotted_line.svg": "1da4",
	"./practices/soccer_goal/game_field.svg": "2f7b",
	"./practices/soccer_goal/goal_shadow.svg": "c115",
	"./practices/soccer_goal/home_grass.svg": "9d3d",
	"./practices/soccer_goal/instructions_background.svg": "97e7",
	"./practices/soccer_goal/life.svg": "6c7c",
	"./practices/soccer_goal/life_dim.svg": "01f0",
	"./progress.svg": "5d31",
	"./rewards.png": "9d98",
	"./ribbon1.png": "dca6",
	"./settings/language.png": "e3d5",
	"./settings/mail-send.png": "c373",
	"./settings/no used-worksheets.png": "ada3",
	"./settings/question-list.png": "a775",
	"./settings/settings-gears.png": "4e0d",
	"./settings/storage.png": "6031",
	"./settings/study.png": "b0c4",
	"./settings/worksheets.png": "8036",
	"./signout/backgrounExitcomic_en.png": "92ce",
	"./signout/backgrounExitcomic_es.png": "d4bc",
	"./signout/exitBallon.png": "8a4c",
	"./signout/exitComicNo.png": "eae1",
	"./signout/exitComicSi.png": "1a84",
	"./signout/exitComicYes.png": "5ad9",
	"./signout/exit_background.png": "fedd",
	"./signout/exit_no_en.png": "2e95",
	"./signout/exit_si_es.png": "b98c",
	"./signout/exit_title_en.png": "e101",
	"./signout/exit_title_es.png": "ea82",
	"./signout/exit_yes_en.png": "fc35",
	"./starsWhite.png": "3e2d",
	"./styles/sass/_mixins.sass": "5f49",
	"./styles/scss/_mixins.scss": "cfcd",
	"./test.svg": "c2db",
	"./test_icon_ccss.svg": "c1fd",
	"./test_icon_ged.svg": "12c8",
	"./test_icon_sat.svg": "b9b3",
	"./tests/elements-1-4/lock-open.gif": "02ca",
	"./tests/elements-1-4/lock_step4_open.png": "2783",
	"./tests/elements-1-4/star-grey.png": "f06c",
	"./tests/elements-1-4/star-yellow.png": "0c80",
	"./tests/elements-5-12/answer1_correct.png": "df2c",
	"./tests/elements-5-12/answer1_incorrect.png": "22f81",
	"./tests/elements-5-12/answer2_correct.png": "c3f0",
	"./tests/elements-5-12/answer2_incorrect.png": "743f",
	"./tests/elements-5-12/answer3_correct.png": "5239",
	"./tests/elements-5-12/answer3_incorrect.png": "ea94",
	"./tests/elements-5-12/answer4_correct.png": "ca34",
	"./tests/elements-5-12/answer4_incorrect.png": "fe61",
	"./tests/elements-5-12/lock_step1_open_5-12.png": "0a2e",
	"./tests/elements-5-12/lock_step2_open_5-12.png": "8d08",
	"./tests/elements-5-12/lock_step3_open_5-12.png": "0bbc",
	"./tests/elements-5-12/lock_step4_open_5-12.png": "2f77",
	"./tests/elements-5-12/pin-green.png": "2f65",
	"./tests/elements-5-12/ribbon4.png": "3c36",
	"./tests/instructions/pasture_field.png": "7535",
	"./tests/instructions/space.png": "397f",
	"./tpm-black.svg": "b4c6",
	"./tpm-logo.svg": "da7f",
	"./tpm-welcome.png": "9300",
	"./tutor/checkAllGreen.png": "7032",
	"./tutor/checkAllGrey.png": "64a9",
	"./tutor/tpm.svg": "435a",
	"./type-tpm.png": "6879",
	"./web.png": "edbf",
	"./worksheets.png": "9399"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";